import React, { createContext, ReactNode, useCallback } from 'react';

import { ProductCollectionDealsItem } from '../../../../types';

export const DealsContext = createContext({
  getDealDiffPercentage: (productId: number) => undefined as undefined | number,
});

type DealsContextWrapperProps = {
  dealsItems: ProductCollectionDealsItem[];
  children: ReactNode;
};
export const DealsContextWrapper = ({
  children,
  dealsItems,
}: DealsContextWrapperProps) => {
  const getDealDiffPercentage = useCallback(
    (productId: number) =>
      dealsItems.find(item => item.productId === productId)?.diffPercentage,
    [dealsItems]
  );
  return (
    <DealsContext.Provider value={{ getDealDiffPercentage }}>
      {children}
    </DealsContext.Provider>
  );
};
